<template>
  <div class="pa-0 ma-0">
    <v-img cover :src="require('../../assets/bg1.jpeg')" height="89vh">
      <v-container
        fluid
        grid-list-xs
        fill-height
        id="overview"
        class="pa-0 ma-0"
      >
        <v-col class="pushTop">
          <v-row justify="center" class="hidden-sm-and-up text-center">
            <h2
              class="white--text pb-0 mb-8 mr-2"
              style="font-size: 30px; font-weight: bold"
            >
              {{ $t("home.mainTitleXs") }}
            </h2>
          </v-row>
          <v-row justify="center" class="hidden-xs-only">
            <h1 class="white--text font-weight-bold mb-0 pb-0 mx-2">
              {{ $t("home.mainTitle") }}
            </h1>
          </v-row>
          <v-row justify="center" class="pushSect hidden-xs-only">
            <h1 class="white--text font-weight-bold mb-0 pb-10 ml-9">
              <br />{{ $t("home.mainTitleSecond") }}
              <span class="typed-text">{{ typeValue }}</span>
              <span class="blinking-cursor">|</span>
              <span class="cursor" :class="{ typing: typeStatus }">&nbsp;</span>
            </h1>
          </v-row>
          <v-row justify="center"> <SearchBar class="mb-5" /> </v-row>
        </v-col>
        <v-row justify="center">
          <v-col cols="11" class="text-center">
            <h2 class="white--text">
              {{ $t("home.heroSubTitle") }}
            </h2>
            <h4 class="white--text hidden-xs-only">
              {{ $t("home.heroDescription") }}
            </h4>
            <v-col class="mt-5">
              <div :class="$vuetify.breakpoint.xs ? 'd-inline-flex' : ''"></div>
              <v-btn color="purple" text :to="`/${$i18n.locale}/landing`">
                <h4 class="white--text mr-1 text-decoration-underline">
                  {{ $t("home.heroUnderlineOptionI") }}
                </h4></v-btn
              >
              <v-btn color="purple" text :to="`/${$i18n.locale}/portfolio`">
                <h4 class="white--text mr-1 text-decoration-underline">
                  {{ $t("home.heroUnderlineOptionII") }}
                </h4></v-btn
              >
            </v-col>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="10" sm="2" offset-sm="1">
            <v-icon size="50" color="white" class="pulsate hidden-xs-only"
              >mdi-arrow-down-bold-hexagon-outline</v-icon
            >
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <!-- Kindergartens and schools home page area -->
    <v-container grid-list-xs>
      <v-row class="mb-10 mt-5">
        <v-col cols="12" sm="10">
          <h2 class="text-center">{{ $t("home.locationsTitle") }}</h2>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col v-for="(card, i) in cards" :key="i" cols="9" sm="3">
          <v-card flat class="rounded-card my-3" max-width="250px">
            <div class="d-inline-flex">
              <v-img
                :src="require('../../assets/' + card.src + '')"
                class="white--text rounded-card"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="100px"
                width="100px"
              >
              </v-img>
              <div class="ml-5">
                <v-row class="my-1 pl-1">
                  <v-icon color="purple" class="mr-1">mdi-map-marker</v-icon>
                  <h4 class="my-1">{{ card.city }}</h4></v-row
                >
                <p class="mb-1 fontP">
                  <span v-if="card.number === 'In curand'">{{
                    $t("home.locationsSoon")
                  }}</span>
                  <span v-if="card.number !== 'In curand'"
                    >{{ card.number }} {{ $t("home.locationsText") }}</span
                  >
                </p>
                <v-btn
                  small
                  color="purple"
                  left
                  @click="routeResolve(card.city)"
                  :disabled="card.disabled"
                  class="text-none white--text"
                >
                  <span class="white--text">
                    <v-icon left class="white--text" size="22"
                      >mdi-arrow-bottom-right</v-icon
                    >
                  </span>
                  <span class="white--text text-none fontBtn">{{
                    $t("home.locationsButton")
                  }}</span></v-btn
                >
              </div>
            </div>
          </v-card>
          <v-divider class="hidden-sm-and-up"></v-divider>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid grid-list-xs>
      <v-row class="mt-10" justify="end">
        <v-col cols="12" sm="5">
          <h2 class="text-center">{{ $t("home.promoTitle") }}</h2>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col v-for="(promo, i) in promotedAccounts" :key="i" cols="10" sm="3">
          <v-card
            flat
            class="rounded-card mt-3 pointer"
            width="100%"
            :to="`/${$i18n.locale}/${promo.username}`"
          >
            <v-img
              v-if="promo.promotionPhotos"
              :src="promo.promotionPhotos[0].url"
              class="white--text rounded-card"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="400px"
              width="400px"
            >
            </v-img>
            <v-row justify="center" class="my-1">
              <v-col cols="11">
                <h4>{{ promo.name }}</h4>
                <p>{{ promo.city }}</p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Courses home page area -->
    <!-- <v-container fluid grid-list-xs v-if="location === 'cursuri'">
      <v-row class="mb-10 mt-5" justify="start">
        <v-col cols="11" sm="5">
          <h1 class="text-center">Descopera cursuri</h1>
        </v-col>
      </v-row>
      <HomeCourses />
    </v-container> -->
    <!-- Clubs home page area -->
    <!-- <v-container fluid grid-list-xs v-if="location === 'cluburi'">
      <v-row class="mb-10 mt-5" justify="start">
        <v-col cols="11" sm="5">
          <h1 class="text-center">Descopera cluburi</h1>
        </v-col>
      </v-row>
      <HomeClubs />
    </v-container> -->
    <v-container fluid grid-list-xs>
      <v-row class="sectDistance">
        <v-card width="100%">
          <v-img
            class="white--text"
            height="500px"
            :src="require('../../assets/register.jpeg')"
          >
            <v-container fluid fill-height grid-list-xs>
              <v-row class="d-flex" align="center" justify="center">
                <v-col cols="11">
                  <v-card-title
                    class="display-2 white--text"
                    v-html="$t('home.heroSubTitle')"
                  ></v-card-title>
                  <p class="ml-6" style="max-width: 400px">
                    {{ $t("landing.heroDescription") }}
                  </p>
                </v-col>
                <v-col cols="11">
                  <v-card-actions>
                    <v-btn
                      outlined
                      class="text-none white--text ml-4"
                      large
                      color="white"
                      :to="`/${$i18n.locale}/landing`"
                    >
                      {{ $t("landing.heroButton") }}</v-btn
                    >
                  </v-card-actions></v-col
                >
              </v-row>
            </v-container>
          </v-img>
        </v-card>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SearchBar from "../../components/SearchBar";
// import HomeCourses from "./HomeCourses.vue";
// import HomeClubs from "./HomeClubs.vue";

export default {
  name: "HomeView",
  components: {
    SearchBar,
    // HomeCourses,
    // HomeClubs,
  },
  data() {
    return {
      category: "Gradinite",
      typeValue: "",
      typeStatus: false,
      displayTextArray: this.$t("home.mainTitleOptions"),
      typingSpeed: 100,
      erasingSpeed: 100,
      newTextDelay: 2000,
      displayTextArrayIndex: 0,
      charIndex: 0,
      cards: [
        {
          src: "bucharest.jpeg",
          disabled: false,
          city: "Bucuresti",
          number: "9",
          link: "/gradinite-scoli/Toate/Bucuresti",
        },

        {
          src: "cluj-napoca.jpeg",
          disabled: true,
          number: "In curand",
          city: "Cluj-Napoca",
          link: "/gradinite-scoli/Toate/Cluj-Napoca",
        },
        {
          src: "constanta.jpeg",
          disabled: true,
          number: "In curand",
          city: "Constanta",
          link: "/gradinite-scoli/Toate/Constanta",
        },
        {
          src: "brasov.jpeg",
          disabled: true,
          number: "In curand",
          city: "Brasov",
          link: "/gradinite-scoli/Toate/Brasov",
        },
      ],
    };
  },
  computed: {
    ...mapState(["promotedAccounts"]),
  },
  created() {
    this.GET_PROMOTED_ACCOUNTS();
    setTimeout(this.typeText, this.newTextDelay + 200);
  },
  methods: {
    ...mapActions(["GET_PROMOTED_ACCOUNTS", "GET_SEARCHED_SCHOOLS"]),
    routeResolve(location) {
      this.$store.commit("SET_SEARCH_INPUT", location);
      this.GET_SEARCHED_SCHOOLS(location);
      let currentLocation = "";
      if (
        this.category === "Gradinite" ||
        this.category === "Scoli" ||
        this.category === "Toate"
      ) {
        currentLocation =
          "/" +
          this.$i18n.locale +
          "/gradinite-scoli/" +
          this.category +
          "/" +
          location;
      } else if (this.category === "Cluburi") {
        currentLocation =
          "/" + this.$i18n.locale + "/cluburi/" + this.select + "/" + location;
      }

      if (currentLocation !== this.$route.fullPath) {
        this.$router.push({ path: currentLocation });
      }
    },
    typeText() {
      if (
        this.charIndex <
        this.displayTextArray[this.displayTextArrayIndex].length
      ) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue += this.displayTextArray[
          this.displayTextArrayIndex
        ].charAt(this.charIndex);
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) this.typeStatus = true;
        this.typeValue = this.displayTextArray[
          this.displayTextArrayIndex
        ].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.displayTextArrayIndex += 1;
        if (this.displayTextArrayIndex >= this.displayTextArray.length)
          this.displayTextArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    },
  },
};
</script>
<style scoped>
.container.grid-list-xs .layout .flex {
  padding: 0px;
}
.centerText {
  text-align: center;
}
.searchBarPos {
  margin-top: 60px;
}
.greySub {
  color: #212121;
}
:deep(.v-text-field__details) {
  display: none;
}
:deep(.v-messages.theme--light) {
  display: none;
}
:deep(div.v-input__slot.white) {
  margin-bottom: 0px;
}
.fontH1 {
  font-size: 60px;
}
.fontP {
  font-style: italic;
  font-size: 16px;
  color: grey;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  background: white !important;
  padding: 0px;
  color: black;
}

.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  .v-label,
.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused
  > .v-input__control
  > .v-input__slot
  input {
  color: black;
}
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn,
.theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: white;
}
:deep(.posRelative) {
  position: relative !important;
}
.posAbsolute {
  position: absolute !important;
  z-index: 2;
}
.bg {
  background: white !important;
}
.bgColor {
  background-color: #6d1bff;
}
.router-link {
  text-decoration: none;
}
.greyBg {
  background: #f6f9ff;
}
.router-link span {
  color: white;
}
.main {
  padding: 55px 0px !important;
}
.fontBtn {
  font-size: 15px;
}
.router-link-menu {
  text-decoration: none;
}
.v-application .display-3 {
  line-height: 2.3rem;
}
.pulsate {
  -webkit-animation: pulsate 2s ease-out;
  -webkit-animation-iteration-count: infinite;
  opacity: 0.5;
}
@-webkit-keyframes pulsate {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.v-list {
  max-height: 25vh; /* or any height you want */
  overflow-y: auto;
}
.sectSpace {
  padding-top: 100px;
  padding-bottom: 70px;
}
.rounded-card {
  border-radius: 14px;
}
h1 {
  font-size: 5.5rem;
  line-height: 3rem;
  font-weight: normal;
}
span.typed-text {
  color: black;
}
.blinking-cursor {
  font-size: 6rem;
  color: black;
  -webkit-animation: 1s blink step-end infinite;
  -moz-animation: 1s blink step-end infinite;
  -ms-animation: 1s blink step-end infinite;
  -o-animation: 1s blink step-end infinite;
  animation: 1s blink step-end infinite;
}
@keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
@-moz-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
@-webkit-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
@-ms-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
@-o-keyframes blink {
  from,
  to {
    color: transparent;
  }
  50% {
    color: black;
  }
}
</style>
